module.exports = __webpack_public_path__ + "a4e6bfc7a854c6ebc18a33b694e9dc37.svg";